module.exports = __webpack_public_path__ + "static/media/16UNODC6.2bb17bd6.jpg";